import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Planning\GetAssignedAssetsController::__invoke
* @see app/Http/Controllers/Planning/GetAssignedAssetsController.php
* @route '/api/planning/{event}/assets'
*/
const GetAssignedAssetsController = (args: { event: string | number | { id: string | number } } | [event: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetAssignedAssetsController.url(args, options),
    method: 'get',
})

GetAssignedAssetsController.definition = {
    methods: ["get","head"],
    url: '/api/planning/{event}/assets',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Planning\GetAssignedAssetsController::__invoke
* @see app/Http/Controllers/Planning/GetAssignedAssetsController.php
* @route '/api/planning/{event}/assets'
*/
GetAssignedAssetsController.url = (args: { event: string | number | { id: string | number } } | [event: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { event: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { event: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            event: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        event: typeof args.event === 'object'
        ? args.event.id
        : args.event,
    }

    return GetAssignedAssetsController.definition.url
            .replace('{event}', parsedArgs.event.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Planning\GetAssignedAssetsController::__invoke
* @see app/Http/Controllers/Planning/GetAssignedAssetsController.php
* @route '/api/planning/{event}/assets'
*/
GetAssignedAssetsController.get = (args: { event: string | number | { id: string | number } } | [event: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetAssignedAssetsController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Planning\GetAssignedAssetsController::__invoke
* @see app/Http/Controllers/Planning/GetAssignedAssetsController.php
* @route '/api/planning/{event}/assets'
*/
GetAssignedAssetsController.head = (args: { event: string | number | { id: string | number } } | [event: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetAssignedAssetsController.url(args, options),
    method: 'head',
})

export default GetAssignedAssetsController